import { connect } from "react-redux"

import CommunityEditHierarchy from "./CommunityEditHierarchy"

import { autocompleteCommunitiesRequest } from "../../../../actions/autocomplete-actions"

const mapStateToProps = ({ presentation: { communities } }) => ({
    reference: communities.workingModel.reference,
    parent: communities.workingModel.parent,
    subType: communities.workingModel.sub_type,
    subGroups: communities.workingModel.sub_groups,
    subCommunities: communities.workingModel.sub_communities
})

const mapDispatchToProps = (dispatch, { onEventChange, onValueChange }) => ({
    onCommunitiesSearch: (searchTerm, callback) => {
        dispatch(autocompleteCommunitiesRequest(searchTerm, callback))
    },
    onEventChange,
    onValueChange
})

export default connect(mapStateToProps, mapDispatchToProps)(
    CommunityEditHierarchy
)
